import type { IConfig } from "config/IConfig";

export default class BalanceService {
    private minimumCashAmount: number;

    constructor(config: IConfig) {
        const amountsToCalculate: number[] = [];

        if (config.enable_bank) amountsToCalculate.push(config.bank_minimum_amount);
        if (config.enable_bizum) amountsToCalculate.push(config.bizum_minimum_amount);
        if (config.enable_verse) amountsToCalculate.push(config.verse_minimum_amount);
        amountsToCalculate.push(config.paypal_minimum_amount);

        this.minimumCashAmount = this.calculateMinimumAmount(amountsToCalculate);
    }

    public shouldDisableRequestRefund(
        availableBalance: number,
        reimbursementTypeAmounts: number[],
    ): boolean {
        const minimumReimbursementTypeAmount =
            this.calculateMinimumAmount(reimbursementTypeAmounts);

        return (
            availableBalance < this.minimumCashAmount &&
            availableBalance < minimumReimbursementTypeAmount
        );
    }

    private calculateMinimumAmount(amountsToCalculate: number[]): number {
        return amountsToCalculate.reduce(
            (minimum, current) => (current < minimum ? current : minimum),
            amountsToCalculate[0],
        );
    }
}
